import { get } from "lodash";
import { initEnquiryForm, EnquiryConfig } from "./enquiry-form";

const safeParseJSON: Function = window["iw"].utils.safeParseJSON;

declare const jQuery: any;
const $ = jQuery;

// - Sets enquiry popup "busy", "error" etc. states in response to its enquiry form.
// - Closes enquiry popup when form successfully submitted.
export function initSingleEnquiryFormPopupStates(): void
{
    const $enquiryPopup = $(`[data-popup="enquiry"]`);
    const $formWrap = $enquiryPopup.find(`.hs-enquiry-form`);
    if ($enquiryPopup.length === 0)
    {
        console.error(`Missing [data-popup="enquiry"]`);
        return;
    }
    $formWrap.off("success complete error submit").on("success", (event) => {
        $enquiryPopup.removeClass("busy");
        const timer = setTimeout(() => {
            $enquiryPopup.trigger("close");
        }, 5000);
        $enquiryPopup.one("close", () => {
            clearTimeout(timer);
        });
    }).on("complete", (event) => {
        $enquiryPopup.removeClass("busy");
    }).on("error", (event) => {
        $enquiryPopup.removeClass("busy").addClass("error");
    }).on("submit", (event) => {
        $enquiryPopup.addClass("busy");
    });
}

export function initSingleExpertContactForm(): void
{
    const $enquiryPopup = $(`[data-popup="enquiry"]`);
    const $formWrap = $enquiryPopup.find(`.hs-enquiry-form`);
    if ($enquiryPopup.length === 0)
    {
        console.error(`Missing [data-popup="enquiry"]`);
        return;
    }
    const supplierPostId: number|undefined = get(window, "iw.supplierPostId");
    $(`[data-expert-contact]`).each(function () {
        const $button = $(this);
        const data = safeParseJSON($button.attr("data-expert-contact"));
        if (!data)
        {
            console.error(`Failed to parse data-expert-contact json`);
            return;
        }
        const expertPostId: number = data.id;
        const config: EnquiryConfig = {
            postId: expertPostId,
            postType: "expert",
            supplierIds: supplierPostId ? [supplierPostId] : undefined,
        };
        $button.on("click", function (event) {
            initEnquiryForm($formWrap, config);
            $enquiryPopup.trigger("open");
            return false;
        });
    });
}

export function initProductSliderEnquiryPopupButtons(): void
{
    const $sliderWrap = $(document.getElementById("products")).find(".slider").first();
    if ($sliderWrap.length === 0)
    {
        return;
    }
    const init = () => {
        const $sliderItems = $sliderWrap.find(`.slider-item [data-post-id]`);
        if ($sliderItems.length === 0)
        {
            return;
        }
        const $enquiryPopup = $(`[data-popup="enquiry"]`);
        const $formWrap = $enquiryPopup.find(`.hs-enquiry-form`);
        if ($enquiryPopup.length === 0)
        {
            console.error(`Missing [data-popup="enquiry"]`);
            return;
        }
        $sliderItems.each(function () {
            const $item = $(this);
            const $button = $item.find(`.enquiry-button`);
            if ($button.length === 0)
            {
                return;
            }
            const postId: number = parseInt($item.attr("data-post-id"), 10);
            const postType = $item.attr("data-post-type");
            const postTitle: string = $item.attr("data-post-title");
            const defaultMsg: string = postTitle ? `Enquiry about ${postTitle}: ` : ``;
            const config: EnquiryConfig = {
                postId,
                postType,
            };
            $button.off("click").on("click", function () {
                initEnquiryForm($formWrap, config, defaultMsg);
                $enquiryPopup.trigger("open");
                return false;
            });
        });
    };
    init();
    if ($sliderWrap.hasClass("infinite-slider"))
    {
        $sliderWrap.on("change reset", init);
    }
}

// non-popup
export function initSupplierContactForm(): void
{
    $(`.hs-supplier-contact-section[data-supplier]`).each(function () {
        const $wrap = $(this);
        const postId: number = parseInt($wrap.attr("data-supplier"), 10);
        const postType = "supplier";
        const config: EnquiryConfig = {
            postId,
            postType
        };
        const $formWrap = $wrap.find(`.hs-enquiry-form`);
        initEnquiryForm($formWrap, config);
    });
}

// non-popup
export function initProductSupplierContactForm(): void
{
    $(`.hs-product-supplier-contact-section[data-supplier]`).each(function () {
        const $wrap = $(this);
        const productTitle: string = $wrap.attr("data-product-title");
        const defaultMsg: string = productTitle ? `Enquiry about ${productTitle}: ` : ``;
        const productPostId: number = parseInt($wrap.attr("data-product"), 10);
        const config: EnquiryConfig = {
            postId: productPostId,
            postType: "product",
        };
        const $formWrap = $wrap.find(`.hs-enquiry-form`);
        initEnquiryForm($formWrap, config, defaultMsg || "");
    });
}
